import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // DiscardDraftAlert
    discardTitle: 'Вернуть опубликованную версию?',
    discardDescription: (subject: string) =>
      `Все неотправленные правки ${subject} будут удалены, и в редакторе снова будет версия, которую сейчас видят ученики. Это действие нельзя отменить.`,
    back: 'Назад',
    discardConfirm: 'Вернуть версию',
  },
  en: {
    discardTitle: 'Revert to the published version?',
    discardDescription: (subject: string) =>
      `All unsent changes to ${subject} will be deleted, and the editor will show the version learners see now. This can’t be undone.`,
    back: 'Back',
    discardConfirm: 'Revert',
  },
})
